import { Phone } from "lucide-react";
import { PHONE_LINK } from "@/lib/constants";

const StickyCallButton = () => {
  return (
    <a
      href={PHONE_LINK}
      className="fixed bottom-4 right-4 z-50 md:hidden gradient-copper text-primary-foreground p-4 rounded-full shadow-copper animate-pulse-copper"
      aria-label="Call us now"
    >
      <Phone className="h-6 w-6" />
    </a>
  );
};

export default StickyCallButton;
